import { useState } from "react";
import { derivedImageUpdateUrl } from "../../helper/UrlResolver";
import Auth from "../../auth/Auth";

interface UpdateDerivedImageResult {
  updateDerivedImage: (
    bucket: string,
    songId: string,
    key: string,
    blob: Blob,
  ) => Promise<boolean>;
  fetching: boolean;
}

export function useUpdateDerivedImage(auth: Auth): UpdateDerivedImageResult {
  const [fetching, setFetching] = useState(false);

  const updateDerivedImage = async (
    bucket: string,
    songId: string,
    key: string,
    blob: Blob,
  ): Promise<boolean> => {
    setFetching(true);
    try {
      const token = auth.getAccessToken();
      if (!token) {
        console.error("Access token is missing");
        return false;
      }

      const formData = new FormData();
      formData.append("file", blob, "image.jpg");

      const url = derivedImageUpdateUrl(bucket, songId, key);
      const response = await fetch(url, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error(
          "Failed to update derived image:",
          response.status,
          errorText,
        );
        return false;
      }

      return true;
    } catch (error) {
      console.error("Error updating derived image:", error);
      return false;
    } finally {
      setFetching(false);
    }
  };

  return {
    updateDerivedImage,
    fetching,
  };
}
